<template>
    <div>
		
        <div class="user_status user_status1 wow animate__animated animate__fadeInUp" v-if="param.check_status == 2">
            <div class="user_status_left">
                <span class="user_statustext">{{$t('m.userinfo_07')}}</span>
                <span class="user_statustext1">/</span>
                <span class="user_statustext2 pointer" @click="seeReason">{{$t('m.userinfo_08')}}</span>
            </div>
			<div class="user_status_right pointer" @click="toExamine">
			    {{$t('m.userinfo_09')}}
			</div>
        </div>
		
        <div class="user_status user_status1 wow animate__animated animate__fadeInUp" v-if="param.check_status == 0">
            <div class="user_status_left">
				<span class="user_statustext">{{$t('m.userinfo_077')}}</span>
			</div>
    <!--        <div class="user_status_right pointer" @click="toExamine">
                {{$t('m.userinfo_09')}}
            </div> -->
        </div>


        <div class="user_bor wow animate__animated animate__fadeInUp">
            <div class="line">

                <div class="user_box">
                    <div class="user_box_left">
                        {{$t('m.userinfo_01')}}
                    </div>
                    <div class="user_box_right">


                        <input type="file" @change="onchangemd" class=" pointer filebox">
                        <div class="orange jiacu pointer">{{$t('m.userinfo_02')}}</div>
                        <img :src="param.head_pic1" alt="">

                    </div>

                </div>

            </div>
        </div>

        <div class="user_bor wow animate__animated animate__fadeInUp">
            <div class="line">

                <div class="user_box">
                    <div class="user_box_left">
                        {{$t('m.userinfo_06')}}
                    </div>
                    <div class="user_box_right">

                    </div>
                </div>
                <div class="waibox">
                    <div class="item item1" v-if="param.check_status == 0">
                        {{$t('m.userinfo_10')}}
                    </div>
                    <div class="item item5">
                        <div class="item_text">
                            <div class="text">{{$t('m.userinfo_03')}}</div>
                        </div>
                        <div class="item_input">
                            <el-input :disabled="disabled" v-model="param.nickname" :placeholder="$t('m.userinfo_16')"></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item_text">
                            <div class="text">{{$t('m.home_14')}}</div>
                        </div>
                        <div class="item_input">
                            <!-- <el-input v-if="param.email" :disabled="true" v-model="param.email" :placeholder="$t('m.userinfo_17')"></el-input> -->
                            <el-input v-if="param.email" v-model="param.email" :placeholder="$t('m.userinfo_17')"></el-input>
                            <el-input v-else v-model="param.email" :placeholder="$t('m.userinfo_17')"></el-input>
                        </div>
                    </div>
                    <div class="item" v-if="param.type == 1">
                        <div class="item_text">
                            <div class="text">{{$t('m.home_13')}}</div>
                        </div>
                        <div class="item_input">
                            <el-input :disabled="disabled" v-model="param.phone" :placeholder="$t('m.userinfo_18')"></el-input>
                        </div>
                    </div>
                    <div class="item" v-if="param.type == 2">
                        <div class="item_text">
                            <div class="text">{{$t('m.userinfo_04')}}</div>
                        </div>
                        <div class="item_input">
                            <el-input :disabled="disabled" v-model="param.company_name" :placeholder="$t('m.userinfo_19')">
                            </el-input>
                        </div>
                    </div>
                    <div class="item" v-if="param.type == 2">
                        <div class="item_text">
                            <div class="text">{{$t('m.userinfo_05')}}</div>
                        </div>
                        <div class="item_input">
                            <el-input :disabled="disabled" v-model="param.company_number" :placeholder="$t('m.userinfo_20')">
                            </el-input>
                        </div>
                    </div>
					
                    <div class="item" v-if="param.type == 2">
                        <div class="item_text">
                            <div class="text3">{{$t('m.userinfo_11')}}</div>
                        </div>
                        <div class="item_input">
                            <div class="upload_box flex f-ct">
								
								<!-- <form action=""></form> -->
								<div class="upimg">
									<!-- <block v-if="isold">
										<img class="yyzhimg" v-if="param.company_img" :src="param.company_img_old" alt="">
									</block>
									<block v-if="!isold">
									</block> -->
									<img class="yyzhimg" v-if="param.company_img" :src="this.$common.baseUrl + param.company_img" alt="">

									<div class="boxn" v-if="!param.company_img">
									    <img src="../../static/images/shanghcuan.png" alt="">
										<span>{{$t('m.userinfo_12')}}</span>
									</div>
									<label class="iptimg" for="iptimg">
										<input ref="input" @change="updatarequest($event)" id="iptimg" type="file" accept="image/*">
									</label>
								</div>
								
								
								
								
								
                                <el-dialog :visible.sync="dialogVisible">
                                    <img width="100%" :src="param.company_img" alt="">
                                </el-dialog>
                            </div>
                        </div>
                    </div>

                    <div class="item item4">
                        <div class="item_text">
                            <div class="text">{{$t('m.userinfo_13')}}</div>

                        </div>
                        <div class="item_text1">
                            {{ param.type == 1 ? $t('m.userinfo_21') : param.type == 2 ? $t('m.userinfo_22') : '' }}
                        </div>
                    </div>
             <!--       <div class="item item2">
                        <div class="item_text">
                            {{$t('m.userinfo_14')}}
                        </div>
                        <div class="item_text1">
                            {{ param.level.name }}
                        </div>
                    </div> -->
                    <div class="item3" v-if="param.check_status != 0">
                        <el-button type="danger" @click="modify">{{$t('m.userinfo_15')}}</el-button>
                    </div>
                </div>

            </div>
        </div>

        <div class="user_bor wow animate__animated animate__fadeInUp">
            <div class="line">

                <div class="user_box">
                    <div class="user_box_left">
                        {{$t('m.userinfo_23')}}
                    </div>
                    <div>

                    </div>

                </div>
                <div class="waibox">
                    <div class="listbox">
                        <!-- <div class="itembox pointer itembox1"> -->
						
						<!-- <div class="g_id_signin" id="g_id_signin"></div> -->
                        <div class="itembox pointer" v-if="!param.google_bind" id="g_id_signin">
                            <img class="icon01" v-if="param.google_bind" src="../../static/facboolicon1.png" alt="">
                            <img class="icon01" v-else src="../../static/facboolicon1_back.png" alt="">
                            <p>{{$t('m.userinfo_24')}}</p>
                        </div>
						
						<div class="itembox pointer" v-if="param.google_bind">
						    <img class="icon01" v-if="param.google_bind" src="../../static/facboolicon1.png" alt="">
						    <img class="icon01" v-else src="../../static/facboolicon1_back.png" alt="">
						    <p>{{$t('m.userinfo_24')}}</p>
						</div>
						
						
						<fb-signin-button
						v-if="!param.facebook_bind"
						:params="fbSignInParams"
						@success="onSignInSuccess"
						@error="onSignInError">
							<div class="itembox pointer">
								<img class="icon02" src="../../static/facebook2_back.png" alt="">
								<p>{{$t('m.userinfo_24')}}</p>
							</div>
						</fb-signin-button>
						
						<div class="itembox pointer" v-if="param.facebook_bind">
							<img class="icon02" src="../../static/facebook2.png" alt="">
							<p>{{$t('m.userinfo_245')}}</p>
						</div>
						
						
      <!--                  <div class="itembox pointer">
                            <img class="icon03" src="../../static/facebook1.png" alt="">
                            <img class="icon03" src="../../static/facebook1_back.png" alt="">
                            <p>{{$t('m.userinfo_24')}}</p>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="showbox3">
            <el-dialog :visible.sync="showbox" :show-close="false" width="350px" center>
                <div class="showbox">
                    <div class="title">{{$t('m.userinfo_25')}}</div>
                    <p>{{ param.check_reason }}</p>
                    <div class="btnboxli">
                        <div class="btnbox1 pointer" @click="showbox = false">
                            <span>{{$t('m.userinfo_26')}}</span>
                        </div>

                    </div>
                </div>

            </el-dialog>
        </div>

    </div>


</template>
<script>

import encryption from '@/utils/encryption.js'
export default {
    components: {


    },
    data() {
        return {
            user_data: {},
            param: {
                nickname: '',
                head_pic: '',
                phone: '',
                company_name: '',
                company_number: '',
                company_img: '',
                user_id: '',
                email: ''
            },
            dialogVisible: false,

            disabled: false,  //禁用输入框
            showbox: false,
			
			isold:true,
			
			fbSignInParams: {
			  scope: 'email,user_likes',
			  return_scopes: true
			},
			googleSignInParams: {
				client_id: "244885048256-4jpnmjm99ppho7ks6i10imq07lqs63e6.apps.googleusercontent.com"
			},
			facebook_id:'',
			google_id:'',
        }
    },
    mounted() {
        this.getdata()
    },
	created() {
		// 使用谷歌登录的api
		const script = document.createElement("script");
		script.src = "https://accounts.google.com/gsi/client"
		document.body.appendChild(script);
		
	
		window.addEventListener('load', () => {
			window.google.accounts.id.initialize({
			   // 主要就是填写client_id
				client_id: "244885048256-4jpnmjm99ppho7ks6i10imq07lqs63e6.apps.googleusercontent.com",
				auto_select: false,
				callback: this.handleCredentialResponse,
			});
			// 设置按钮的样式等
			window.google.accounts.id.renderButton(
				document.getElementById("g_id_signin"),
				{
					theme: "filled_blue",
					size: 'large',
					// width:'320',
					type: 'standard',
					text: 'signin_with'
				}
			);
		})
	},
    methods: {
		async handleCredentialResponse(response) {
			// 获取回调响应的凭证数据 然后拿这个凭证给后台，后台jwt进行解析获取登录信息
			console.log(response)
			var that = this
			var data = {credential:response.credential}
			let sing = encryption.getSing(data)
			this.$api.google_account_decode(data, sing).then(res => {
				if (res.data.code == 1) {
					that.google_id = res.data.data
					that.modify()
				}
			})
		},
		// 脸书
		onSignInSuccess (response) {
			// 登录成功回调
			// FB.api('/me', dude => {
			//   console.log(`Good to see you, ${dude.name}.`)
			// })
			console.log('facebook成功回调',response.authResponse.userID) //返回第三方的登录信息 tolen等
			// this.login_other(1,response.authResponse.userID)
			this.facebook_id = response.authResponse.userID
			this.modify()
		},
		onSignInError (error) {
			//登录失败回调
			console.log('facebook失败回调',error) 
			this.$message.warning(this.$t('m.home_011'))
		},
        getdata() {
            // console.log(666666666666)
            let user_data = JSON.parse(localStorage.getItem('user_data'))
            let user_id = user_data.id || ''
            let param = {
                user_id: user_id
            }

            let sing = encryption.getSing(param)
            this.$api.get_user_info(param, sing).then((res) => {
                if (res.data.code == 1) {
					res.data.data.head_pic1 = res.data.data.head_pic
                    this.param = res.data.data
                    localStorage.setItem('user_data', JSON.stringify(res.data.data))
					
					if(this.param.company_img){
						// this.dialogVisible = true
						this.param.company_img_old =  this.param.company_img
						this.param.company_img = this.param.company_img
					}
					// console.log(this.param)
                    

                    if (res.data.data.check_status == 0) {
                        this.disabled = true
                    }
                    this.$parent.getuserdata()
					
                }
				
				
				
            })
			
        },
        handleRemove(file, fileList) {
            console.log('删除')
            console.log(file, fileList);
        },
        handlePictureCardPreview(file) {
            this.param.company_img = file.url;
            this.dialogVisible = true;
            console.log('查看')
			
        },
		// 上传图
        updatarequest(event) {
			if(this.param.check_status==0){
				return
			}
            // let files = event.target.files[0];
			var files = event.target.files[0]
			console.log(files)
            let param = new FormData()
            param.append("file", files)
            console.log(param)
            this.$api.upload_business_license(param).then((res) => {
				this.param.company_img = res.data.data.file_path || ''
                // console.log(this.param.company_img)
				this.isold = false
                // this.getdata()
            })
        },
		// 修改
        modify(is_audit) {
            let param = new Object
            param.head_pic = this.param.head_pic.split(this.$common.baseUrl)[1]
            param.company_img = this.param.company_img
            // param.company_img = this.param.company_img.split(this.$common.baseUrl)[1]
            param.nickname = this.param.nickname || ''
            param.user_id = this.param.id
            param.phone = this.param.phone || ''
            param.company_name = this.param.company_name || ''
            param.company_number = this.param.company_number || ''
            param.email = this.param.email

            console.log(param)
            
            if (this.param.type == 1) {
                if (!param.phone) {
                    this.$message.warning(this.$t('m.userinfo_27'))
                    return
                }
            } else if (this.param.type == 2) {
                if (!param.company_name) {
                    this.$message.warning(this.$t('m.userinfo_19'))
                    return
                } else if (!param.company_number) {
                    this.$message.warning(this.$t('m.userinfo_20'))
                    return
                } else if (!param.company_img) {
                    this.$message.warning(this.$t('m.userinfo_28'))
                    return
                }
            }
			
			
			 if(is_audit){
				param.is_audit = 1
			 }else{
				param.is_audit = 0
			 }
			 
			 
			 if(this.facebook_id){
				 param.facebook_id = this.facebook_id
			 }
			 if(this.google_id){
			 	param.google_id = this.google_id
			 }
			 
			// console.log(param)
			let sing = encryption.getSing(param)
            this.$api.user_edit(param, sing).then((res) => {
                if (res.data.code == 1) {
                    this.$message.success(this.$t('m.userinfo_29'))
                    let user_data = res.data.data
                    localStorage.setItem('user_data', JSON.stringify(user_data))
                    this.getdata()
                }
            })
        },
        //提交审核
        toExamine() {
			this.modify(1)
        },
        //查看原因
        seeReason() {
            this.showbox = true
        },
        //修改头像
        onchangemd(e) {
            console.log(e.target.files)//这个就是选中文件信息
            let param = new FormData()
            param.append('file', e.target.files[0])
            console.log(param)
            this.$api.upload_head_pic(param).then((res) => {
                if (res.data.code == 1) {
                    this.param.head_pic = this.$common.baseUrl + res.data.data.file_path || ''
                    this.param.head_pic1 = this.$common.baseUrl + res.data.data.file_path || ''
                    // this.modify()
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.waibox {
    padding: 0 50px;
}

.item2 {
    margin-top: 40px !important;
}

.item4 {
    margin-top: 30px !important;
}

.item5 {
    margin-top: 20px;
}

.item1 {
    font-size: 14px;
    color: #2e3341;
	padding-bottom: 15px;
}

.item3 {
    margin-top: 30px;

    .el-button {
        width: 150px !important;
        height: 50px !important;
        background-color: #ef5843;
        font-weight: bold;
        padding: 0 !important;
    }
}

.item {
    display: flex;
    align-items: center;
    margin-top: 12px;



    .item_text {
        min-width: 140px;
        color: #2e3341;

        font-size: 15px;

        .text {
            color: #2e3341;
            min-width: 70px;
            // text-align: justify;
            // text-align-last: justify;
            text-justify: inter-ideograph;
            /*兼容ie*/

        }
    }

    .item_text1 {
        margin-left: 20px;
        font-size: 15px;
        font-weight: bold;
        .text3{
            width: 100%;
        }
    }

    .item_input {
        ::v-deep .el-input__inner {
            height: 50px;
            line-height: 50px;
            width: 300px;
            color: #2e3341 !important;
            font-size: 15px !important;
            font-weight: bold !important;
        }
    }
}

.listbox {
    display: flex;
    align-items: center;
    margin-top: 30px;

    .itembox1 {
        border: 3px solid #ef5843 !important;
        background-color: #fdf4f3;
        color: #ef5843;
    }

    .itembox {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-right: 13px;
        min-width: 100px;
        min-height: 80px;
		padding: 10px;
        border-radius: 4px;
        border: 3px solid #e5e5e5;
		text-align: center;

        .icon01 {}

        .icon02 {}

        .icon03 {
            width: 30px;
            height: 25px;
        }


        p {
            font-size: 14px;
            margin-top: 10px;
        }
    }
}



.user_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-left: 5px solid #ef5843;
    height: 26px;
    padding-right: 30px;
    padding-left: 20px;

    .user_box_left {
        padding-left: 25px;
    }


    .user_box_right {
        display: flex;
        align-items: center;
        position: relative;

        .filebox {
            position: absolute;
            opacity: 0;
            z-index: 99;

            right: 0px;
        }

        img {
            margin-left: 10px;
            width: 50px;
            height: 50px;
            border-radius: 50%;
        }
    }
}

::v-deep .el-input.is-disabled .el-input__inner {
    color: #000000;
    font-size: 16px;
}

.user_status {
    border: 3px solid #ef5843;
    border-radius: 4px;
    width: 100%;
    height: 70px;
    background-color: #fff;
    font-size: 15px;
    line-height: 70px;
    padding-left: 30px;

    span {
        font-weight: bold;
    }

    .user_statustext {
        color: #ef5843;

    }

    .user_statustext1 {

        margin-left: 10px;
    }

    .user_statustext2 {
        color: #005efc;
        margin-left: 10px;

    }
}

.user_status1 {
    white-space: nowrap;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .user_status_left {
        display: flex;
        flex: 1;
        align-items: center;
    }

    .user_status_right {
        width: 140px;
        height: 70px;
        background-color: #ef5843;
        color: #fff;
        font-weight: bold;
        text-align: center;
        line-height: 70px;
    }
}

.showbox3 {
    ::v-deep .el-dialog__body {
        padding: 0 !important;
        border-top: 5px solid #ef5843;
        border-radius: 4px;
    }

    ::v-deep .el-dialog__header {
        padding: 0 !important;
    }

    ::v-deep .el-dialog {
        border-radius: 4px;
        margin-top: 35vh !important;
    }
}




::v-deep .el-dialog__headerbtn .el-dialog__close {
    display: none;
}

.showbox {
    padding: 30px;
    background-color: #fff;

    .bar {
        font-weight: bold;
        text-align: center;
    }

    .title {
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        margin-top: 0 !important;

    }

    p {
        margin-top: 10px;
        text-align: center;
    }

    .btnboxli {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 40px;


        .btnbox {
            background-color: #ef5843;
            height: 50px;
            width: 120px;
            font-weight: bold;
            display: flex;
            align-items: center;
            color: #fff;
            border-radius: 4px;
            justify-content: center;
            margin-left: 20px;

        }

        .btnbox1 {
            background-color: #fff;
            color: #ef5843;
            border: 3px solid #ef5843;
            border-radius: 4px;
            height: 50px;
            width: 120px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;


        }
    }
}

.upload_box {
    margin-top: 20px;
    text-align: left !important;


}

.yyzhimg{width: 146px;height: 146px;border-radius: 8px;margin-right: 10px;}
.boxn {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    line-height: normal;
    width: 144px;
    height: 144px;
	border: 1px dashed #aaa;
	border-radius: 8px;
    span {
        margin-top: 6px;
        color: #697185;
    }
}
.upimg{
	position: relative;
}
.iptimg{
	background: pink;
	width: 144px;
	height: 144px;
	display: block;
	position: absolute;
	top: 0;
	left: 0;
	opacity: 0;
}



// 宽度小于1200px
@media screen and (max-width: 1200px){
	.user_status{
		height: auto;
		padding: 1rem;
		display: block;
	}
	.user_status1{
		white-space: normal;
		line-height: 1.5rem;
	}
	.user_status_left{
		display: block!important;
	}
	.user_statustext{
		text-align: justify;
	}
	.user_status_right{
		margin: auto;
		width: auto!important;
		padding: 0 1rem;
		margin-top: 0.8rem;
	}
	.user_box{
		height: auto;
		padding-left: 0;
		.jiacu{
			display: none;
		}
	}
	.waibox{
		padding: 0 1rem;
		.item{
			display: block;
			.item_text{
				min-width: 100%;
				margin-bottom: 10px;
			}
		}
		.item2{
			display: flex;
			.item_text{
				width: auto!important;
				min-width: 0;
				margin-bottom: 0px;
			}
		}
		.item4{
			display: flex;
			.item_text{
				width: auto!important;
				margin-bottom: 0px;
				min-width: 0;
			}
		}
	}
}
</style>